/** Kuraterede danske tekster til Træningsbane (~250–300 tegn, niveau 5+). */

export interface FlowChunk {
  topic: string;
  text: string;
}

export const FLOW_CHUNKS_DA: FlowChunk[] = [
  {
    topic: 'bier',
    text: 'Bier kan flyve langt for at finde nektar fra blomster. De danser på trækpladsen for at vise vej til honning. En arbejderbi kan besøge hundredvis af blomster på én dag. Bier er vigtige for maden vi spiser, fordi de bestøver planter. En bikube kan have tusindvis af bier om sommeren.',
  },
  {
    topic: 'havet',
    text: 'Havet dækker det meste af Jorden og påvirker vejret overalt. Bølger skyller ind mod kysten hver dag og former sand og klipper. Mange fisk lever dybt under overfladen, hvor det er mørkt og koldt. Havstrømme transporterer varme rundt på kloden. Dykning kræver ro, øvelse og respekt for naturen.',
  },
  {
    topic: 'vinter',
    text: 'Om vinteren bliver dagene kortere i Danmark, og mørket kommer tidligt. Frost kan lægge et tyndt lag is på søer og kanaler. Mange tager varmt tøj på, før de går ud i den kolde luft. Træer mister blade, men venter på foråret under barken. Vinteren giver også tid til ro, læsning og varm kakao.',
  },
  {
    topic: 'kroppen',
    text: 'Hjertet pumper blod rundt i kroppen hele tiden, også når du sover. Lungerne tager ilt ind, når du trækker vejret, og sender det videre i blodet. Muskler hjælper dig med at bevæge dig, løbe og holde balance. Knogler giver kroppen støtte, og huden beskytter mod bakterier. Kroppen er et samspil af mange dele.',
  },
  {
    topic: 'cykel',
    text: 'En cykel har to hjul og en kæde, der driver baghjulet fremad. Mange danskere cykler til skole og arbejde, også når det regner lidt. En hjelm beskytter hovedet, hvis du falder, og lygter hjælper i mørket. At cykle styrker ben og giver frisk luft i lungerne. Det er en billig og god måde at komme rundt på.',
  },
  {
    topic: 'bøger',
    text: 'En bog består af mange sider med tekst, der fortæller en historie eller forklarer noget. Biblioteker låner bøger ud gratis, så alle kan læse. Det er rart at læse en god historie om aftenen, når dagen er stille. Læsning øver sproget og giver nye idéer. Nogle bøger husker man længe efter sidste side.',
  },
  {
    topic: 'mad',
    text: 'Grøntsager og frugt giver vitaminer til kroppen, så du kan holde dig rask. Rugbrød er en klassisk dansk mad, ofte med pålæg til frokost. Det er godt at drikke vand i løbet af dagen, især når du har travlt. Måltider kan samle familie og venner om et bord. God mad behøver ikke være fancy for at smage godt.',
  },
  {
    topic: 'rummet',
    text: 'Månen kredser om Jorden cirka hver måned og påvirker tidevandet langs kysterne. Solen er en stjerne, der giver os lys, varme og energi til planter. Astronauter har været på månen og har taget billeder af Jorden derfra. Rummet er stort og koldt, og der er ingen luft at trække vejret i. Teleskoper hjælper os med at se langt væk.',
  },
  {
    topic: 'årstider',
    text: 'Foråret kommer, når træerne får knopper og fuglene vender tilbage. Om sommeren kan det være lyst sent om aftenen, og folk er ofte udenfor. Efteråret bringer blade i røde og gule farver, der falder til jorden. Vinteren føles lang, men gør foråret dejligt, når det vender. Årstiderne skifter langsomt og giver rytme i året.',
  },
  {
    topic: 'dyr',
    text: 'Hunden er et af de ældste dyr, mennesker har tæmmet, og den kan være en tro ven. Katte sover mange timer om dagen og jager legetøj med stille poter. Fugle bygger rede for at lægge æg og passe unger, til de kan flyve. Dyr lever i skove, marker og hav, hver på sin måde. Vi deler planeten med dem.',
  },
  {
    topic: 'musik',
    text: 'Musik kan få folk til at synge og danse sammen, selv når de ikke kender hinanden. Et kor synger i flere stemmer på én gang og skal lytte til de andre. Øvelse gør det lettere at spille et instrument og finde rytmen. Nogle sange minder os om en bestemt tid eller et sted. Musik kan både være stille og meget kraftfuld.',
  },
  {
    topic: 'søvn',
    text: 'Børn har brug for mere søvn end voksne, fordi kroppen vokser og lærer meget. Kroppen hviler og genopbygger sig om natten, mens drømme kommer og går. Det er sværere at koncentrere sig, når man er træt, og fejl kommer lettere. En rolig aften uden skærme kan hjælpe med at falde i søvn. God søvn er en gave til næste dag.',
  },
];
